import React, { createContext, Reducer, useReducer } from 'react';

export type UserInfoState = {
	userInfoInitialized: boolean;
	email: string;
	emailVerified: boolean;
}

export type Actions = SetUserInfo;

export type SetUserInfo = {
	type: 'setUserInfo';
	email: string;
	emailVerified: boolean;
}

const Dispatch = createContext<React.Dispatch<Actions>>(() => {});
const State = createContext<UserInfoState>({
	userInfoInitialized: false,
	email: '',
	emailVerified: false
});

const reducer: Reducer<UserInfoState, Actions> = (state, action) => {
	switch (action.type) {
		case 'setUserInfo':
			return {
				userInfoInitialized: true,
				email: action.email,
				emailVerified: action.emailVerified
			};

		default:
			throw new Error('Invalid action type in User Info reducer');
	}
}

function Provider({ children }: { children: JSX.Element[] | JSX.Element }) {
	const [state, dispatch] = useReducer(reducer, {
		userInfoInitialized: false,
		email: '',
		emailVerified: false
	});

	// The state and the dispatch function should be provided separately so that components that are interested
	// only in dispatching events don't need to use the state and thus re-render when the state changes
	// See here - https://reactjs.org/docs/hooks-faq.html#how-to-avoid-passing-callbacks-down
	return (
		<State.Provider value={state}>
			<Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
		</State.Provider>
	)
}

export const UserInfo = {
	State,
	Dispatch,
	Provider
};